export default {
  ArTitleCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
